import { render, staticRenderFns } from "./AppLocalPage.vue?vue&type=template&id=1b35b9a8"
import script from "./AppLocalPage.vue?vue&type=script&lang=js"
export * from "./AppLocalPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports